import React, { Fragment, useCallback, useEffect } from 'react';
import { translate } from '../Services/translation';
import { updateRecommendedPrice } from '../Actions/Recommendedprice.action';
import useSessionStorage from '../Actions/SessionStorage.action';
import { useSelector, useDispatch } from 'react-redux';

const RecommendedPriceToggle = (props) => {
  const dispatch = useDispatch();
  const isrecommendedprice = useSelector(
    (state) => false
  );
  const { showRecommendedPriceSection } = window.__litium.channelConfig;
  const [getShowPrice, setShowPrice] = useSessionStorage(
    'ShowRecommendedPrice',
    isrecommendedprice
  );
  const updateRecommendedPriceValue = useCallback(
    (status) => {
      setShowPrice(status);
      dispatch(updateRecommendedPrice(status));
    },
    [dispatch, setShowPrice]
  );
  useEffect(() => {
    if (showRecommendedPriceSection) {
      dispatch(updateRecommendedPrice(getShowPrice));
    }
  }, [showRecommendedPriceSection, dispatch, getShowPrice]);
  return (
    <Fragment>
      {' '}
      {showRecommendedPriceSection && (
        <div className="recommended-outer">
          <span className="recommended-title">
            {translate('recommendedprice.introduction')}
          </span>
          <a
            className={'rec-price ' + (getShowPrice ? 'active' : '')}
            onClick={() => updateRecommendedPriceValue(true)}
          >
            {translate('recommended.include')}
          </a>
          <a
            className={getShowPrice ? '' : 'active'}
            onClick={() => updateRecommendedPriceValue(false)}
          >
            {translate('recommended.exclude')}
          </a>
        </div>
      )}
    </Fragment>
  );
};

export default RecommendedPriceToggle;
